import type { MarketSelectorValue } from '../../../../MarketSelector/types';

export function getPriceGridMarketSelectorSelections(
  marketSelectorValue: MarketSelectorValue | undefined,
  marketsByName: ReadonlyMap<string, unknown>,
  marketAccountsByName: ReadonlyMap<string, unknown>
) {
  const selections = marketSelectorValue?.selections ?? [];
  const selectedMarketAccounts = selections.filter(selection => marketAccountsByName.has(selection));
  const selectedMarkets = selections.filter(
    selection => !marketAccountsByName.has(selection) && marketsByName.has(selection)
  );

  return { selectedMarkets, selectedMarketAccounts };
}
